import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CompleteIcon, DefaultIcon } from 'assets/materialIcons/materialIcons';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';
import { colors } from 'material-ui/styles';
import DateUTCField from 'components/field/DateFields/DateUTCField';

const styles = {
    status: {
        paddingLeft: '5px',
        paddingRight: 0,
        width: '10%',
    },
    cell: {
        paddingRight: '5px',
        paddingLeft: '5px',
    },
};

class ReservationSessionActivities extends Component {
    renderStatusIcon = (status) => {
        switch (status) {
            case 'finished':
                return <CompleteIcon color={ colors.lightGreen600 }/>;
            default:
                return <DefaultIcon color={ colors.grey400 }/>;
        }
    }

    render() {
        const {
            activities,
            translate,
        } = this.props;

        return (
            <Table>
                <TableBody displayRowCheckbox={ false }>
                    <TableRow>
                        <TableRowColumn style={ styles.status }>
                            { translate('resources.reservations.show.activities.access_sessions.status') }
                        </TableRowColumn>
                        <TableRowColumn style={ styles.cell }>
                            { translate('resources.reservations.show.activities.access_sessions.started_at') }
                        </TableRowColumn>

                        <TableRowColumn style={ styles.cell }>
                            { translate('resources.reservations.show.activities.access_sessions.ended_at') }
                        </TableRowColumn>

                    </TableRow>

                    {
                        utils.map(activities, (activity, index) => {
                            const {
                                status,
                            } = activity;

                            return (
                                <TableRow key={ `activity_${ index }` }>
                                    <TableRowColumn style={ styles.status }>{
                                        this.renderStatusIcon(status)
                                    }</TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>
                                        <DateUTCField
                                            record={ activity }
                                            source='started_at'
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={ styles.cell }>
                                        <DateUTCField
                                            record={ activity }
                                            source='ended_at'
                                        />
                                    </TableRowColumn>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        );
    }
}

ReservationSessionActivities.propTypes = {
    activities: PropTypes.array.isRequired,
    translate: PropTypes.func,
};

export default translate(ReservationSessionActivities);


// WEBPACK FOOTER //
// ./src/pages/reservations/show/session/ReservationSessionActivities.js